import React, { useEffect } from "react";
import { connect } from "react-redux";
import { loadFooter } from "./FooterSlice";
import FooterSection from "../../components/FooterSection";
import { getServicesDatareq, getExperiencesDatareq, getFooterDatareq } from "./FooterSlice";

const FooterContainer = ({
  loadFooter,
  quickLinks,
  experiences,
  transportation,
  company,
  contacts,
  getServicesDatareq,
  servicesPageData,
  getExperiencesDatareq,
  experiencesPageData,
  getFooterDatareq
}) => {
  // useEffect(() => {
  //   loadFooter();
  // }, [loadFooter]);
  useEffect(() => {
    getServicesDatareq();
  }, [getServicesDatareq]);
  useEffect(() => {
    getExperiencesDatareq();
    getFooterDatareq();
  }, [getExperiencesDatareq, getFooterDatareq]);
  return (
    <FooterSection
      quickLinks={quickLinks}
      experiences={experiencesPageData}
      transportation={transportation}
      company={company}
      contacts={contacts}
      services={servicesPageData}
      getFooterDatareq={getFooterDatareq}
    />
  );
};

const mapStateToProps = (state) => ({
  quickLinks: state.footer.quickLinks,
  experiences: state.footer.experiences,
  transportation: state.footer.transportation,
  company: state.footer.company,
  contacts: state.footer.contacts,
  servicesPageData: state.footer.servicesPageData,
  experiencesPageData: state.footer.experiencesPageData,
});

const mapDispatchToProps = {
  loadFooter,
  getServicesDatareq,
  getExperiencesDatareq,
  getFooterDatareq
};

export default connect(mapStateToProps, mapDispatchToProps)(FooterContainer);
